import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { motion, useAnimation } from 'framer-motion';
import {
  setFrontendSkills, setBackendSkills, setToolSkills, setCommunicationSkills, setSoftSkills,
} from '../../redux/actions/actionCreate';
import {
  frontendSkillsData, backendSkillsData, toolsSkillsData, communicationSkillsData, softSkillsData,
} from './SkillsData';
import Imageside from './imageside';
// import { images } from '../../constants';
import './About.scss';

const About = () => {
  const dispatch = useDispatch();
  const frontendSkills = useSelector((state) => state.frontendskills);
  const backendSkills = useSelector((state) => state.backendskills);
  const toolSkills = useSelector((state) => state.toolskills);
  const communicationSkills = useSelector((state) => state.communicationskills);
  // const softSkills = useSelector((state) => state.softskills);
  const controls = useAnimation();

  const handleScroll = () => {
    const yOffset = window.scrollY;
    if (yOffset >= 0) {
      controls.start({ y: 0 }); // Stick to the top
    } else {
      controls.start({ y: yOffset }); // Scroll with the content
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    dispatch(setFrontendSkills(frontendSkillsData));
    dispatch(setBackendSkills(backendSkillsData));
    dispatch(setToolSkills(toolsSkillsData));
    dispatch(setCommunicationSkills(communicationSkillsData));
    dispatch(setSoftSkills(softSkillsData));
  }, []);

  const about = 'aBOUT mE.';
  return (
    <motion.div
      className="app__about"
      id="about"
    >
      <div className="about-profile">
        <h1 className="about-title">
          {about}
          <span className="blink-dash" />
        </h1>
        <Imageside animate={controls} />
        <p className="about-paragraph">
          MY JOURNEY IN THE WORLD OF PROGRAMMING BEGAN IN 2018,
          WHEN I VENTURED INTO FREELANCING. SINCE THEN, I HAVE
          HAD THE OPPORTUNITY TO WORK ON A WIDE RANGE OF PROJECTS,
          HONING MY SKILLS AND EXPANDING MY KNOWLEDGE ALONG THE WAY.
          I HAVE WORKED WITH VARIOUS CLIENTS, BOTH INDEPENDENTLY AND
          AS PART OF A TEAM, TO DELIVER INNOVATIVE AND USER-FRIENDLY
          WEBSITES AND MOBILE APPLICATIONS.
        </p>
      </div>
      <div className="details-center">
        <div>
          <h2>Front-End</h2>
          <div className="about_skills-frontend">
            {
              frontendSkills.map((skill) => (
                <div key={skill.id} className="about-js">
                  <div className="frontend-icons">
                    <img src={skill.image} alt={skill.name} />
                  </div>
                  <p>{skill.name}</p>
                </div>
              ))
            }
          </div>
        </div>
        <div>
          <h2>Back-End</h2>
          <div className="about_skills-frontend">
            {
              backendSkills.map((skill) => (
                <div key={skill.id} className="about-js">
                  <div className="frontend-icons">
                    <img src={skill.image} alt={skill.name} />
                  </div>
                  <p>{skill.name}</p>
                </div>
              ))
            }
          </div>
        </div>
        <div>
          <h2>Tools</h2>
          <div className="about_skills-frontend">
            {
              toolSkills.map((skill) => (
                <div key={skill.id} className="about-js">
                  <div className="frontend-icons">
                    <img src={skill.image} alt={skill.name} />
                  </div>
                  <p>{skill.name}</p>
                </div>
              ))
            }
          </div>
        </div>
        <div>
          <h2>Communication Skills</h2>
          <div className="about_skills-frontend">
            {
              communicationSkills.map((skill) => (
                <div key={skill.id} className="about-js">
                  <div className="frontend-icons">
                    <img src={skill.image} alt={skill.name} />
                  </div>
                  <p>{skill.name}</p>
                </div>
              ))
            }
          </div>
        </div>
        {/* <div>
          <h3>Soft Skills</h3>
          <div>
            {
              softSkills.map((skill) => (
                <div key={skill.id} className="soft-skills">
                  <p>{skill.name}</p>
                </div>
              ))
            }
          </div>
        </div> */}
      </div>
    </motion.div>
  );
};

export default About;
